/**
 * React Query staleTime values (ms).
 * Data is refetched only after this duration or when the query key is invalidated.
 */
export const STALE_TIME_DETAIL_MS = 10 * 60 * 1000; // 10 min
export const STALE_TIME_LIST_MS = 5 * 60 * 1000; // 5 min
